<script setup>
  import Icon from "@/components/icons/Icon.vue";

  const selectedProfiles = defineModel({ default: () => [] });
  
  const props = defineProps({
    profiles: {
      type: Array,
      required: true
    }
  });
</script>

<template>
  <div class="jwx-modal__section">
    <ul class="jwx-save-to-selector">
      <li v-for="profile in props.profiles" class="jwx-save-to-selector__item" :key="profile.profile_id">
        <input
          @change="handleContainerProfileSelection"
          type="checkbox"
          :name="`jwx-${profile.profile_id}`"
          :id="`jwx-${profile.profile_id}`"
          :value="profile.profile_id"
          v-model="selectedProfiles"
          class="jwx-save-to-selector__input jwx-hidden-control"
        />
        <label :for="`jwx-${profile.profile_id}`" class="jwx-save-to-selector__label">
          <h4 class="jwx-save-to-selector__label-title">
            {{ profile.name }}
          </h4>
          <div class="jwx-save-to-selector__selection-indicator">
            <Icon name="checkmark" class="jwx-save-to-selector__indicator-icon" />
          </div>
        </label>
      </li>
    </ul>
  </div>
</template>